import { create } from "zustand";
import { fetchActivityLog } from "../services/activityLogService";
import { useErrorStore } from "components"; // Використовуємо ваш useErrorStore

// Глобальний стор (state manager) сторінки історії.
export const usePageHistoryStore = create((set, get) => ({
  // --- Стан даних ---
  logs: [],
  totalCount: 0,
  isLoading: false,
  isOpen: false,

  // --- Стан фільтрів ---
  parentSubjects: [],
  config: null,
  externalFilters: {},
  filters: {
    activeSubjectType: "all",
    search: "",
    page: 1,
    pageSize: 25,
  },

  // --- Функції та діі ---

  // Ініціалізація стору.
  init: (subjects, config, contextFilters = {}) => {
    set({
      parentSubjects: subjects,
      config: config,
      externalFilters: contextFilters,
    });
  },

  // Завантаження історії.
  fetchLogs: async () => {
    set({ isLoading: true });
    const { filters, parentSubjects, externalFilters } = get();

    // Визначаємо, які 'subject_types' відправляти на API
    let apiSubjectTypes = [];
    if (filters.activeSubjectType === "all") {
      apiSubjectTypes = parentSubjects;
    } else {
      apiSubjectTypes = [filters.activeSubjectType];
    }

    try {
      // Об'єднуємо стандартні параметри та externalFilters
      const { data, totalCount: total } = await fetchActivityLog({
        subject_types: apiSubjectTypes,
        subject_identifier: filters.search,
        page: filters.page,
        page_size: filters.pageSize,
        ...externalFilters,
      });

      set({
        logs: data,
        totalCount: total || 0,
        isLoading: false,
      });
    } catch (error) {
      console.error("Failed to fetch activity log:", error);
      const { showError } = useErrorStore.getState();
      showError("Не вдалося завантажити історію.");
      set({ logs: [], totalCount: 0, isLoading: false });
    }
  },

  // Перемикач видимості sidebar.
  toggleSidebar: () => {
    const wasOpen = get().isOpen;
    if (!wasOpen) {
      set({
        isOpen: true,
        // Скидаємо фільтри до дефолту при кожному відкритті
        filters: {
          activeSubjectType: "all",
          search: "",
          page: 1,
          pageSize: 25,
        },
        logs: [],
        totalCount: 0,
      });
      // externalFilters не скидаємо, бо вони задані через init
      get().fetchLogs();
    } else {
      set({ isOpen: false });
    }
  },

  // Універсальна функція для зміни будь-якого фільтра.
  setHistoryFilter: (newFilter) => {
    set((state) => ({
      filters: {
        ...state.filters,
        ...newFilter,
        page: 1, // Скидаємо на першу сторінку при зміні фільтрів
      },
    }));
  },

  // Функція для зміни сторінки
  setPage: (page) => {
    set((state) => ({
      filters: { ...state.filters, page: page },
    }));
    get().fetchLogs();
  },
}));
